import React from 'react';
import OwnerForm from '../components/OwnerForm';
 

function Stuff() {
 
    return (
      <div>
        <OwnerForm  />

       
      </div>
    );
}

export default Stuff;
